export const VERIFY_SUCCESS = 'verify_success';
export const VERIFY_BILLING = 'verify_billing';
export const SAVE_BILLING = 'save_billing';
export const SAVE_SUCCESS = 'save_success';
export const RESET_STATE = 'reset_state';
